import { dayPart, hourAdjust } from './utils';

export const timeFormatter = (dateStr: any) => {
  const date = new Date(dateStr);
  const hours = date.getHours();
  return `${hourAdjust(hours)}:${date.getMinutes()}:${date.getSeconds()} ${dayPart(hours)}`;
};
